import {Feature} from 'geojson'
import { ExtraFuncType } from "../../../Logic/ExtraFunctions";
import { Utils } from "../../../Utils"
export class ThemeMetaTagging {
   public static readonly themeName = "openlovemap"

   public metaTaggging_for_brothel(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_stripclub(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_erotic_shop(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_shops(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_condom_vending_machine(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
      const {distanceTo, overlapWith, enclosingFeatures, intersectionsWith, closest, closestn, get} = helperFunctions
      Utils.AddLazyProperty(feat.properties, '_vending_count', () => feat.properties.vending.split(';').length ) 
   }
   public metaTaggging_for_vending_machine(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
      const {distanceTo, overlapWith, enclosingFeatures, intersectionsWith, closest, closestn, get} = helperFunctions
      Utils.AddLazyProperty(feat.properties, '_vending_count', () => feat.properties.vending.split(';').length ) 
   }
   public metaTaggging_for_erotic_cinema(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_cinema(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_love_hotel(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_tourism_accomodation(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
   public metaTaggging_for_toilet(feat: Feature, helperFunctions: Record<ExtraFuncType, (feature: Feature) => Function>) {
   }
}